export const ERROR_MESSAGES = {
  general: 'Oops! Something went wrong. Contact Support discovery@reedsy.com if this happens again.',
};

const formatKey = (key) => `${ key.charAt(0).toUpperCase()}${key.substr(1).replace(/\./i, ' ')}`;

export const getErrorMessage = (originalError) => {
  if (originalError && originalError.message === 'Request aborted') return;

  if (!originalError) {
    return ERROR_MESSAGES.general;
  }

  if (originalError.response && originalError.response.data) {
    return getErrorMessage(originalError.response.data);
  }

  if (originalError.errors) {
    let errorMsgs = '';
    Object.keys(originalError.errors).forEach((key) => {
      const errorMsg = key === 'base' ?
        originalError.errors[key] :
        `${ formatKey(key) }: ${ originalError.errors[key]}`;
      const separator = (errorMsgs ? '\n' : '');
      errorMsgs = `${ errorMsgs }${ separator }${ errorMsg }`;
    });

    return errorMsgs;
  }

  if (originalError.error) {
    return originalError.error;
  }

  return ERROR_MESSAGES.general;
};
